module.exports = __webpack_public_path__ + "img/CS48Q-中_13.34661b56.jpg";